import { removeNonNumeric } from "src/primitive/string";

export const NO_US_ZIPCODE = "noUsZipcode";

function normalizePostalCode(input: string): string {
  if (!input) {
    return input;
  }

  let numericOnly = removeNonNumeric(input);
  numericOnly = numericOnly.slice(0, 5);

  return numericOnly;
}

export default normalizePostalCode;
